import { render, staticRenderFns } from "./faqimbtn.vue?vue&type=template&id=569700d4&"
import script from "./faqimbtn.vue?vue&type=script&lang=js&"
export * from "./faqimbtn.vue?vue&type=script&lang=js&"
import style0 from "./faqimbtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports